import React from "react";

function StyleDesign() {
    return <div></div>;
}

export default StyleDesign;
